import { Routes, Route, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import ProtectedRoute from './components/ProtectedRoute'
import HomePage from './pages/HomePage'
import DashboardPage from './pages/DashboardPage'
import Dashboard from './components/Dashboard'
import LoginPage from './pages/LoginPage'
import AdminPage from './pages/AdminPage'
import InvitationAcceptancePage from './pages/InvitationAcceptancePage'
import { ApiService } from './services/api'

function App() {
  const [apiStatus, setApiStatus] = useState<'loading' | 'connected' | 'error'>('loading')
  const location = useLocation()
  
  // Check if current page is login page
  const isLoginPage = location.pathname === '/login'

  useEffect(() => {
    // Test backend connection
    ApiService.getStatus()
      .then(() => setApiStatus('connected'))
      .catch(() => setApiStatus('error'))
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Only show header and footer if not on login page */}
      {!isLoginPage && <Header apiStatus={apiStatus} />}
      
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/accept-invitation/:token" element={<InvitationAcceptancePage />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/core-briefing" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </main>
      
      {!isLoginPage && <Footer />}
    </div>
  )
}

export default App 